function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FF5F00",
  d: "M8.749 6.117h6.461v11.665H8.75z"
}), React.createElement("path", {
  fill: "#EB001B",
  d: "M9.159 11.95a7.417 7.417 0 012.82-5.833 7.361 7.361 0 00-9.988.8 7.442 7.442 0 000 10.065 7.361 7.361 0 009.988.8 7.417 7.417 0 01-2.82-5.831z"
}), React.createElement("path", {
  fill: "#F79E1B",
  d: "M23.928 11.95a7.42 7.42 0 01-4.157 6.672 7.358 7.358 0 01-7.792-.84 7.43 7.43 0 002.822-5.832 7.43 7.43 0 00-2.822-5.833 7.358 7.358 0 017.792-.84 7.42 7.42 0 014.157 6.671v.003zm-.705 4.594v-.238h.096v-.05h-.244v.05h.104v.238h.044zm.473 0v-.287h-.073l-.087.205-.086-.205h-.065v.287h.053v-.215l.08.186h.055l.08-.186v.217l.043-.002z"
})));

var SvgMastercard = function SvgMastercard(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mastercard.4ac79e14.svg";
export { SvgMastercard as ReactComponent };